import { Icon } from "@msuite/ui/icons";
import { Popover } from "@msuite/ui/popover";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { ProjectPopover } from "@/components/popovers/project-popover";
import { client } from "@/hono";

/** Props Interface */
interface ProjectCardMentionInlineProps {
	projectId: string;
}

export function ProjectCardMentionInline({ projectId }: ProjectCardMentionInlineProps) {
	/** Hooks */
	const { data: project } = useQuery({
		queryKey: ["project", projectId],
		queryFn: async () => {
			const response = await client.projects[":projectId"].$get({
				param: { projectId },
			});
			const json = await responseHandler(response);
			return json.project;
		},
	});

	return (
		<Popover
			trigger="hover"
			variant="plain"
			render={() => <ProjectPopover projectId={projectId} />}
		>
			<p className="text-accent-500!">
				<Icon
					name="FolderOpen"
					className="inline -translate-y-0.5 mr-1"
				/>
				<span className="underline underline-offset-3">{project?.name}</span>
			</p>
		</Popover>
	);
}
